module.exports = __webpack_public_path__ + "static/img/pic23.f5eca71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic23.png
// module id = ijLS
// module chunks = 1